import logo from './logo.svg';
import './App.css';
import Home from './Components/Home';
import Header from './Components/Header';

function App() {
  return (
    <>
      <Header/>
      <Home/>
    </>
  );
}

export default App;
